export class CreatePurchasingGroupCommand {
    constructor(
        public readonly code: string,
        public readonly name: string,
        public readonly description?: string,
        public readonly companyCodeIds: readonly string[] = [],
    ) {}
}
